/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/blocks/credits.module.scss';

const propTypes = {
    names: PropTypes.arrayOf(PropTypes.string),
    role: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    names: [],
    role: null,
    className: null,
};

const CreditsBlock = ({ names, role, className }) => {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
        >
            {role !== null ? <p className={styles.label}>{role}</p> : null}
            {names !== null
                ? names.map((name) => (
                      <p key={`credit-${name}`} className={styles.name}>
                          {name}
                      </p>
                  ))
                : null}
        </div>
    );
};

CreditsBlock.propTypes = propTypes;
CreditsBlock.defaultProps = defaultProps;

export default CreditsBlock;
